<!--
  +---------------------------------------------------------------------------------------
  | @Author:    leo<zhudongxian@frippler.com>
  | @Title:     手机绑定
  +---------------------------------------------------------------------------------------
-->

<template>
  <el-dialog class="f-mobile-bind" width="900px" title="绑定手机号" :visible.sync="dialogShow" :modal-append-to-body="false" :close-on-click-modal="false" @closed="onDialogClosed">
    <el-alert title="手机号仅用于登录及密码找回，我们不会泄露您的手机信息" type="info" :closable="false" show-icon />
    <div class="text-center" style="width: 420px; margin: 80px auto">
      <el-form ref="postForm" :model="formData" :rules="formRules" label-position="left" label-width="100px">
        <el-form-item label="手机号" prop="mobile">
          <el-input v-model="formData.mobile" placeholder="请输入手机号码" prefix-icon="el-icon-mobile-phone" clearable @input="checkMobile">
            <template slot="prepend">+86</template>
          </el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <el-input v-model="formData.code" placeholder="请输入验证码" clearable>
            <template slot="append">
              <el-button style="width: 200px;" :loading="btnLoading" @click="sendCode">
                <span v-if="!sending && !times">获取手机验证码</span>
                <span v-if="!sending && times">重新获取验证码</span>
                <span v-if="sending">{{ interval - counter }}秒后，重新获取验证码</span>
              </el-button>
            </template>
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="text-center mb">
      <el-button class="extend" plain @click="dialogShow = false">取消</el-button>
      <el-button class="extend" type="primary" :disabled="!formData.mobile || !formData.code" @click="onPostFormSubmit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { validateNumber } from '@/utils/validate'

import { postUserInfoApi } from '@/api/fam/famUserApi'

export default {
  name: 'FMobileBind',
  components: {
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data () {
    var validateMobile = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入11位手机号码'))
      } else {
        // if (this.mobileMsg) callback(new Error(this.mobileMsg))
        if (validateNumber(value)) {
          callback()
        } else {
          return callback(new Error('请输入真实的手机号码！'))
        }
      }
    }

    return {
      times: 0,
      btnLoading: false,
      sending: false,
      counter: 0,
      interval: 60,

      formData: {
        mobile: null,
        code: null
      },
      formRules: {
        mobile: [
          { min: 11, max: 11, message: '手机号码长度不正确', trigger: 'blur' },
          { validator: validateMobile, trigger: 'blur' }
        ],
        code: [
          { min: 4, max: 4, message: '请填写正确的验证码', trigger: 'blur' },
          { required: true, message: '验证码不能为空', trigger: 'blur' }
        ]
      }
    }
  },

  computed: {
    dialogShow: {
      get () {
        return this.show
      },
      set (val) {
        this.$emit('update:show', val)
      }
    }
  },

  watch: {
    counter () {
      if (this.counter > this.interval) {
        this.sending = false
        this.counter = 0
        if (this.timer) {
          clearInterval(this.timer)
        }
      }
    }
  },

  created () {
  },

  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },

  methods: {
    checkMobile () {
    },

    sendCode () {
      if (this.sending) return
      this.btnLoading = true
      const temp = {
        mobile: this.formData.mobile,
        send: 1
      }
      postUserInfoApi(temp).then((res) => {
        this.btnLoading = false
        if (!res.errno) {
          this.sending = true
          this.$message.success('验证码已发送到你的新手机号，1小时内有效！')
          this.times++
          this.timer = setInterval(() => {
            this.counter += 1
          }, 1000)
        } else {
          this.sending = false
          this.$message.error(res.message)
        }
      })
    },

    resetData () {
      this.formData.mobile = null
      this.formData.code = null
    },

    onDialogClosed () {
      this.resetData()
      this.$nextTick(() => {
        this.$refs['postForm'].clearValidate()
      })
    },

    onPostFormSubmit () {
      this.$refs['postForm'].validate((valid) => {
        if (valid) {
          this.$store.dispatch('setUserInfoAction', this.formData).then((res) => {
            if (!res.errno) {
              this.$message.success(res.message)
              this.dialogShow = false
            } else {
              this.$message.error(res.message)
            }
          }).catch((err) => {
            console.log(err)
          })
        }
      })
    }
  }
}
</script>

<style lang="scss">
.el-input--suffix .el-input__inner {
  padding-right: 15px;
}
</style>
